/**
 *
 * Footer
 *
 */

import { Box, SystemStyleObject, Text } from '@chakra-ui/react';

const Footer = () => {
	const styles: Record<string, SystemStyleObject> = {
		containerFooter: {
			bg: 'primary.600',
			py: '5px',
			width: '100%',
			position: 'absolute',
			bottom: 0,
			height: '35px',
			textAlign: 'center',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
		containerText: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			flexDirection: {
				base: 'column',
				md: 'row',
			},
		},
		textFooter: {
			color: 'primary.100',
			fontWeight: 'light',
			fontSize: '10px',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
	};

	return (
		<Box sx={styles.containerFooter}>
			<Box sx={styles.containerText}>
				<Text sx={styles.textFooter}>Todos os direitos reservados. Copyright &copy; 2023 Afya Educacional -</Text>
				<Text color="primary.100" fontWeight="bold" fontSize="10px" ml="5px">
					Política de privacidade - Pedido do titular
				</Text>
			</Box>
		</Box>
	);
};

export { Footer };
